import React from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import {withApollo} from "react-apollo";
import $ from 'jquery';
import _ from 'lodash';

import withStyles from "material-ui/styles/withStyles";
import sweetAlertStyle from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.jsx";
import Button from 'components/CustomButtons/Button.jsx';
import CustomInput from 'components/CustomInput/CustomInput.jsx';
import ItemGrid from "components/Grid/ItemGrid.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import Radio from 'material-ui/Radio/Radio';
import RadioGroup from 'material-ui/Radio/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';

import { getGroups } from '../graph';
import Select from 'react-select';

class ImportUsersModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      importSuccess: false,
      groupType: 0,
      options: [],
      selectedGroup: null,
      groupName: "", 
      successAlert: null
    }

    this.confirmImport=this.confirmImport.bind(this);
  }
  handleChange = (event) => {
    const target = event.target;
    const name = target.name;
    let value = target.value;
    if (name === "groupType"){
      value = parseInt(value);
    }
    this.setState({
      [name]: value
    });
  }

  handleSelectChange = (data) => {
    this.setState({
      selectedGroup: data.value
    });
  }

  componentDidUpdate(prevProps, prevState){
    if (prevState.groupType === 0 && this.state.groupType === 1){
      let options = [];
      if(_.isEmpty(this.props.getProjectGroups.getProjectGroups)){
        alert("No existing groups, create a new group instead");
        this.setState({
          groupType: 0
        });
      }
      else{
        this.props.getProjectGroups.getProjectGroups.map((group, index) => {
          options.push({label: `${group.groupId}-${group.name}`, value: group.groupId})
        });

        this.setState({
          options: options,
          selectedGroup: options[0].value
        });
      }
    }

  }

  hideSuccessAlert(){
    this.setState({
      successAlert: null
    })
    this.props.handleClose();
  }
  
  confirmImport(event){
        // Need to use Native XMLHttpRequest to Send File via ajax-like
        // event.stopPropagation()
        // event.preventDefault()
        const { groupType, selectedGroup, groupName} = this.state;
        let _this = this;
        var url = `${process.env.REACT_APP_SERVER_URL}api/${this.props.pid}/users/import`;
        let xhr = new XMLHttpRequest();
        xhr.addEventListener("progress", updateProgress);
        xhr.open('POST', url, true);
        xhr.setRequestHeader('Authorization', localStorage.getItem("APN_AUTH_TKN"));
        let formData = new FormData($('#upload-file')[0]);
        formData.append("groupType", groupType);
        formData.append("groupName", groupName);
        formData.append("groupID", selectedGroup);
        xhr.send(formData);
        //xhr.send(selectedGroup);

        function updateProgress (oEvent) {
          if (oEvent.lengthComputable) {
            var percentComplete = oEvent.loaded / oEvent.total;
            _this.setState({
                uploadProgress: (percentComplete * 100) + "%"
            });
            if (percentComplete == 1){
              console.log("done");
            }
          } else {
            console.log("oops, something went wrong");
          }
        }

        xhr.onreadystatechange = function() {
            if (xhr.readyState == XMLHttpRequest.DONE) {
                var data = JSON.parse(xhr.responseText).data
                if (data.message == "success"){
                      console.log(data)
                      _this.props.onSuccess();
                      let users_not_imported = (data.users_not_imported.length > 0) ?
                            `Failed to add ${data.users_not_imported.length} users to project.` : "";
    
                      _this.setState({
                        successAlert: <SweetAlert
                            success
                            style={{ display: "block", marginTop: "-100px" }}
                            title="Success!"
                            onConfirm={() => _this.hideSuccessAlert()}
                            onCancel={() => _this.hideSuccessAlert()}
                          >
                            Successfully imported {data.users_imported} users. <br/>
                            {users_not_imported}
                          </SweetAlert>,
                        importSuccess: true
                      })
                    } else {
                      _this.setState({
                        successAlert: <SweetAlert
                            danger
                            style={{ display: "block", marginTop: "-100px" }}
                            title="Oops!"
                            onConfirm={() => _this.hideSuccessAlert()}
                            onCancel={() => _this.hideSuccessAlert()}
                          >
                            Something went wrong! 
                          </SweetAlert>,
                        importSuccess: true
                      })
                    }
            }
      } 
  }

  render() {
    const { classes } = this.props;
    const { groupType, selectedGroup, options } = this.state;

    if (this.props.project == 0) {
      return <div>alert("Please select a project")</div>
    }
    return(
        <SweetAlert
          onConfirm={(event) => this.confirmImport(event)}
          onCancel={this.props.handleClose} 
          confirmBtnCssClass={
            this.props.classes.button + " " + this.props.classes.success
          }
          cancelBtnCssClass={
            this.props.classes.button + " " + this.props.classes.danger
          }
          confirmBtnText="Import"
          cancelBtnText="Cancel"
          showCancel
          title={"Import Users to Project " + this.props.project}
          style={{overflow: "visible !important"}}
        >  
          {this.state.successAlert}
          <GridContainer>
            <ItemGrid xs={12}>
            <form id="upload-file" method="post" encType="multipart/form-data">
              <p> Choose a file to upload. </p>
              <p> </p>   
              <input type="file" name="file" id="file" />

              <label>New Group</label>
              <Radio
                  checked={groupType === 0}
                  onChange={this.handleChange}
                  value="0"
                  name="groupType"
                  aria-label="New Group"

                />
                <label>Existing Group</label>
                <Radio
                  checked={groupType === 1}
                  onChange={this.handleChange}
                  value="1"
                  name="groupType"
                  aria-label="Existing Group"
                />
                {(groupType === 0) ? 
                  <input type="text"  name="groupName" placeholder="Group name here.." className="form-control" label="New Group Name" onChange={this.handleChange}/> :
            
                  <Select
                    name="selectedGroup"
                    onChange={this.handleSelectChange}
                    options={options}
                    value={selectedGroup}
                    placeholder="Select Table"
                    clearable={false}
                  />
                }
               {this.state.importSuccess}
             
             </form>
            </ItemGrid>
           </GridContainer>
        </SweetAlert>
    )
  }
}

export default  withStyles(sweetAlertStyle)((getGroups)(ImportUsersModal));


// WEBPACK FOOTER //
// ./src/views/users/components/ImportUsersModal.js